import React from 'react';
import { useNavigation } from '@react-navigation/native';
import StubScreen from './_StubScreen';

export default function DiagnoseScreen() {
  const navigation = useNavigation();
  return (
    <StubScreen
      title="AI Diagnose"
      sourcePath="garageiq-web/app/(main)/diagnose/DiagnoseClient.jsx"
      summary="Snap a photo (or video) of a warning light, leak, or worn part. The AI identifies the issue and links to the matching repair guide."
      todo={[
        'Wire react-native-image-picker for camera + library access (already in package.json).',
        'Replace web FileReader/base64 with picker.assets[].base64 — saves to AsyncStorage under garageiq_diagnostic_history.',
        'Audio recording is in the web app via MediaRecorder; on RN install react-native-audio-recorder-player.',
        'Each issue category in DiagnoseClient maps 1:1 to a tab — port them as a TabBar across the top.',
        'Diagnosis history list reuses StepUserContent\'s storage shape — port StepUserContent first to share the helper.',
      ]}
      ctaLabel="Browse Guides Instead →"
      onCta={() => navigation.navigate('MainTabs', { screen: 'Guides' })}
    />
  );
}
